import { RestClient } from '../lib/RestClient'

class PessoaService extends RestClient {
  constructor() {
    super('pessoa')
  }
}
export const Pessoa = new PessoaService()
